module.exports = __webpack_public_path__ + "img/product-8.71a73bea.png";